import { Result } from 'antd';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { BaseButton } from '../../../components/base-button/BaseButton';
import { setLoadingPageGlobal } from '../../../redux/globalReducer';
import { DEFAULT_PAGE } from '../../../utils/constants/AppConstants';
import { Ii18n } from '../../../utils/interfaces/i18n';

const NotAuthorized = () => {
  const { t }: Ii18n = useTranslation();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLoadingPageGlobal(false));
  }, []);

  // function redirect to the login page
  const goBackHome = () => {
    window.location.href = DEFAULT_PAGE;
  };

  return (
    <div className='flex items-center h-[100vh]'>
      <Result
        status='403'
        title='403'
        subTitle={t('error:not_authorized:sub_title')}
        extra={
          <div className='w-full flex items-center justify-center'>
            <BaseButton type='primary' size='large' onClick={goBackHome}>
              Back Home
            </BaseButton>
          </div>
        }
        className='m-auto'
      />
    </div>
  );
};

export default NotAuthorized;
